import { getReferenceDataURL } from "~/routes";
import {
    CatalogListItem,
    type CatalogListItemBadge,
} from "~/modules/catalog/components/CatalogListItem";
import type { ReferenceData } from "~/modules/reference_data/types";

export function ReferenceDataItem({
    item,
    totalAssetCount,
}: {
    item: ReferenceData;
    totalAssetCount?: number;
}) {
    const badges: CatalogListItemBadge[] = [
        {
            title: "Category",
            label: item.category,
        },
        {
            title: "Assets",
            label:
                totalAssetCount !== undefined
                    ? `${item.asset_count.toLocaleString()} / ${totalAssetCount.toLocaleString()}`
                    : `${item.asset_count.toLocaleString()}`,
        },
        {
            title: "Slug",
            label: item.slug,
            mono: true,
        },
    ];

    return (
        <CatalogListItem
            label={item.name}
            slug={item.slug}
            href={getReferenceDataURL({ referenceSlug: item.slug })}
            description={item.short_description}
            icon={item.icon}
            color={item.color}
            badges={badges}
        />
    );
}
